// extracted by mini-css-extract-plugin
export default {"toastsWrapper":"EccsLk_XDUgpk8Q3VNSg","toasts-wrapper":"WDdpuQ1_cjIfTRBjbNaR"};